module.exports = __webpack_public_path__ + "media/application/images/demo/content_6-43ede43a509ee68a60ef555e12b651a0.jpg";